import React from "react";
import { Link } from "react-router-dom";
import { Heart, Youtube, Facebook, Instagram, MessageCircle } from "lucide-react";
import { MINISTRY } from "@/data/site";

const ICONS = { Youtube, Facebook, Instagram, MessageCircle };

const socials = [
  { name: "YouTube", icon: "Youtube", url: "https://www.youtube.com/@orphôss" },
  { name: "Facebook", icon: "Facebook", url: "https://www.facebook.com/steevehorphoss" },
  { name: "Instagram", icon: "Instagram", url: "https://www.instagram.com/steeveorphosss/" },
  { name: "WhatsApp", icon: "MessageCircle", url: "https://wa.me/33758798906" },
];

export const TopBar = () => {
  return (
    <div className="bg-brown-dark text-ivory" data-testid="top-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="relative flex items-center justify-between h-11">
          <div className="hidden md:block w-48" />
          <p className="absolute left-1/2 -translate-x-1/2 font-heading tracking-[0.25em] text-sm sm:text-base text-gold-light whitespace-nowrap">
            {MINISTRY.name}
          </p>
          <div className="flex items-center gap-1.5 sm:gap-2 ml-auto">
            {socials.map((s) => {
              const Icon = ICONS[s.icon];
              return (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.name}
                  data-testid={`topbar-social-${s.name.toLowerCase()}`}
                  className="p-1.5 rounded-full text-ivory/70 hover:text-gold-light hover:bg-white/5 transition-colors duration-300"
                >
                  <Icon size={16} />
                </a>
              );
            })}
            <Link
              to="/faire-un-don"
              data-testid="topbar-donate-button"
              className="hidden sm:inline-flex items-center gap-1.5 ml-2 px-3.5 py-1.5 rounded-full bg-gold text-white text-xs font-semibold tracking-wide hover:bg-gold-light transition-colors duration-300"
            >
              <Heart size={13} fill="currentColor" />
              Faire un don
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
